import { isGoogleSignInConfigured, publicEnv } from "@/src/config/publicEnv";

export const GOOGLE_CLIENT_ID = publicEnv.googleClientId;

export { isGoogleSignInConfigured };
